/** Shared helpers for journal entry dates, sorting, and living-doc display. */

import { DOC_TYPES } from '../constants';

export { DOC_TYPES };

/** Published date (original `date` column). */
export const getPublishedDate = (post) => post?.date;

/** Last updated: `updated_at` when present, otherwise published date. */
export const getLastUpdated = (post) => post?.updated_at || post?.date;

export const isLivingDoc = (post) => post?.doc_type === DOC_TYPES.LIVING;

export const sortByLastUpdated = (posts) =>
  [...posts].sort(
    (a, b) => new Date(getLastUpdated(b)) - new Date(getLastUpdated(a))
  );

const toDateKey = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const formatJournalDate = (value) => toDateKey(value);

export const formatShortJournalDate = (value) =>
  new Date(value).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

/** "Published … · Updated …" when dates differ; otherwise a single date line. */
export const formatDateLine = (post) => {
  const published = getPublishedDate(post);
  const updated = getLastUpdated(post);
  const publishedKey = toDateKey(published);
  const updatedKey = toDateKey(updated);

  if (publishedKey && updatedKey && publishedKey !== updatedKey) {
    return {
      published: publishedKey,
      updated: updatedKey,
      single: null,
    };
  }

  return {
    published: null,
    updated: null,
    single: publishedKey || updatedKey,
  };
};

/** Normalise changelog from DB (array of { date, note }). */
export const getChangelog = (post) => {
  const raw = post?.changelog;
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((entry) => entry && (entry.date || entry.note))
    .sort((a, b) => new Date(b.date) - new Date(a.date));
};
